<div class="grid">
  <div class="col-12">
    <div class="col-2">
      <p-fileUpload #csvImportUsers name="userCSVFile" [customUpload]="true"
                    chooseLabel="{{'COMMON.BROWSE'|translate}}"
                    [showCancelButton]="false"
                    [showUploadButton]="false"
                    [multiple]="true"
                    mode="basic"
                    accept=".csv"
                    (onSelect)="checkFileContent($event, csvImportUsers)"></p-fileUpload>
    </div>
    <div class="col-3">
    </div>
    <div class="col-2">
      <button  pButton type="button" [label]="'COMMON.IMPORT_TEMPLATE' | translate" class="p-button-success"
               (click)="getImportTemplate()"></button>
    </div>
    <div class="col-3">
    </div>
    <div class="col-2 right-float">
      <button [disabled]="!users || errorMessage"  pButton type="button" [label]="'COMMON.IMPORT_LIST' | translate" class="p-button-success"
              (click)="importUsers()"></button>
    </div>
  </div>

  <div class="col-12" style="font-size: 1.2em">
    <div class="col-12">{{errorMessage}}</div>
    <div class="col-12" style="max-height: 300px; overflow-y: auto;">
      <div class="col-12" *ngFor="let message of messages">{{message}}</div>
    </div>

  </div>
  <div class="col-12" *ngIf="users">
    <p-table [value]="users">

      <ng-template pTemplate="header">
        <tr>
          <th>{{'GROUPS.ACTION'|translate}}</th>
          <th>{{'GROUPS.ID'|translate}}</th>
          <th>{{'GROUPS.EMAIL'|translate}}</th>
          <th>{{'GROUPS.ROLE'|translate}}</th>
          <th>{{'GROUPS.FIRST_NAME'|translate}}</th>
          <th>{{'GROUPS.LAST_NAME'|translate}}</th>
          <th>{{'GROUPS.DEFAULT_LANGUAGE'|translate}}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user>
        <tr>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown appendTo="body" [options]="operations" [(ngModel)]="user.action" [style]="{'width':'100%'}"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="user.action.toUpperCase() === 'ADD'">Ajout</span>
                <span *ngIf="user.action.toUpperCase() === 'UPDATE'">MAJ</span>
                <span *ngIf="user.action.toUpperCase() === 'DELETE'">Supp.</span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="user.userName">
              </ng-template>
              <ng-template pTemplate="output">
                {{user.userName}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="user.email">
              </ng-template>
              <ng-template pTemplate="output">
                {{user.email}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown appendTo="body" [options]="roles" [(ngModel)]="user.role" [style]="{'width':'100%'}"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="user.role.toUpperCase() === 'SUPERVISOR'">{{'COMMON.TITLES.SUPERVISOR' | translate}}</span>
                <span *ngIf="user.role.toUpperCase() !== 'SUPERVISOR'">{{'COMMON.TITLES.USER' |translate}}</span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="user.firstName">
              </ng-template>
              <ng-template pTemplate="output">
                {{user.firstName}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="user.lastName">
              </ng-template>
              <ng-template pTemplate="output">
                {{user.lastName}}
              </ng-template>
            </p-cellEditor>
          </td>
          <td pEditableColumn>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-dropdown appendTo="body" [options]="locales" [(ngModel)]="user.defaultLocale" [style]="{'width':'100%'}"></p-dropdown>
              </ng-template>
              <ng-template pTemplate="output">
              <span *ngIf="user.defaultLocale === 'FR'">{{'COMMON.LANGUAGES.LANG_FR' |translate }}</span>
              <span *ngIf="user.defaultLocale !== 'FR'">{{'COMMON.LANGUAGES.LANG_EN' |translate }}</span>
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
